import { BlogPost } from './../../../models/blogpost';
import { Component, OnInit } from '@angular/core';
import { BlogPostService } from '../../../services/blog-post.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import * as siteSource from 'src/app/site/sitesource';
import * as videos from './blog';
@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit {
  body:SafeHtml;
  postId: number;
  blog:BlogPost=new BlogPost();
  apiurl:string;
  constructor(private blogService:BlogPostService,private avRoute: ActivatedRoute, private router: Router,private sanitizer: DomSanitizer) {
    siteSource.showLoading();
    this.apiurl=environment.appUrl;
      const idParam = 'id';
    if (this.avRoute.snapshot.params[idParam]) {
      this.postId = this.avRoute.snapshot.params[idParam];
    }
    if(this.postId==null || this.postId==0)
      router.navigateByUrl('/blogs');
    this.blogService.getBlogPost(this.postId).subscribe((res)=>{
      this.blog=res;
      this.body=this.sanitizer.bypassSecurityTrustHtml(res.body);
      setTimeout(() => {
    siteSource.hideLoading();
      }, 1000);

  })
  }
  ngOnInit() {
  }
ngAfterContentInit(): void {
  //Called after ngOnInit when the component's or directive's content has been initialized.
  //Add 'implements AfterContentInit' to the class.
  setTimeout(() => {
    videos.videoblog();
      }, 2000); setTimeout(() => {
        videos.videoblog();
          }, 3000); setTimeout(() => {
            videos.videoblog();
              }, 4000); setTimeout(() => {
                videos.videoblog();
                  }, 5000); setTimeout(() => {
                    videos.videoblog();
                      }, 7000); setTimeout(() => {
                        videos.videoblog();
                          }, 10000);setTimeout(() => {
                            videos.videoblog();
                              }, 13000);setTimeout(() => {
                                videos.videoblog();
                                  }, 15000);setTimeout(() => {
                                    videos.videoblog();
                                      }, 17000);
  }
}
